"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_media_1 = __importDefault(require("react-media"));
var EventStack_1 = __importDefault(require("../EventStack"));
var FormGroupContext_1 = __importDefault(require("../FormGroup/FormGroupContext"));
var styled_components_1 = __importDefault(require("../Themes/styled-components"));
var Input_1 = __importDefault(require("./Input"));
var Options_1 = __importStar(require("./Options"));
var OptionsModal_1 = __importDefault(require("./OptionsModal"));
var utils_1 = require("./utils");
var ContainerWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n"], ["\n  position: relative;\n  width: 100%;\n"])));
function default_1(props) {
    var inputEl = React.useRef(null);
    var _a = React.useState(false), isTouchDevice = _a[0], setIsTouchDevice = _a[1];
    var _b = React.useState(false), isModalOpened = _b[0], setIsModalOpened = _b[1];
    var _c = React.useState(''), inputValue = _c[0], setInputValue = _c[1];
    var _d = React.useState(false), focused = _d[0], setFocused = _d[1];
    var _e = React.useState(-1), focusIdx = _e[0], setFocusIdx = _e[1];
    var formGroupContext = React.useContext(FormGroupContext_1.default);
    var _f = props.options, options = _f === void 0 ? [] : _f, disabled = props.disabled, onFocus = props.onFocus, onBlur = props.onBlur, multiple = props.multiple, _g = props.value, value = _g === void 0 ? multiple ? [] : null : _g, onChange = props.onChange, createNewOption = props.createNewOption, _h = props.filterOptions, filterOptions = _h === void 0 ? utils_1.defaultFilterOptions : _h, loading = props.loading, onChangeInput = props.onChangeInput, error = props.error, placeholder = props.placeholder, renderLabel = props.renderLabel, _j = props.clearable, clearable = _j === void 0 ? true : _j;
    React.useEffect(function () {
        if (isTouchDevice && focused) {
            setIsModalOpened(true);
        }
    }, [focused, isTouchDevice]);
    var filteredOptions = React.useMemo(function () {
        return filterOptions === null
            ? options
            : filterOptions(options, inputValue);
    }, [options, inputValue, filterOptions]);
    var allOptions = React.useMemo(function () {
        return createNewOption &&
            inputValue &&
            !utils_1.containsExactMatch(filteredOptions, inputValue)
            ? __spreadArrays(filteredOptions, [utils_1.getDefaultCreateOption(inputValue)]) : filteredOptions;
    }, [filteredOptions, inputValue, createNewOption]);
    React.useEffect(function () {
        if (focused) {
            if (!Array.isArray(value) && value) {
                setFocusIdx(allOptions.findIndex(function (o) { return o.value === value.value; }));
            }
        }
    }, [focused, allOptions, value]);
    var noop = React.useCallback(function () { }, []);
    function handleBlur() {
        EventStack_1.default.remove(document.body, 'keydown', noop);
        if (onBlur) {
            onBlur();
        }
        setInputValue('');
        setFocused(false);
    }
    function handleFocus(e) {
        EventStack_1.default.add(document.body, 'keydown', noop);
        if (isTouchDevice) {
            setIsModalOpened(true);
        }
        else {
            if (onFocus) {
                onFocus(e);
            }
            setFocused(true);
            setFocusIdx(0);
        }
    }
    function handleSelectOption(selectedOption) {
        var selected = selectedOption;
        if (createNewOption &&
            selectedOption &&
            selectedOption.value === Options_1.CREATE_OPTION_VALUE) {
            selected = createNewOption(inputValue);
        }
        if (multiple) {
            if (Array.isArray(value)) {
                var idx = value.findIndex(function (val) {
                    return val.value === selected.value;
                });
                if (idx === -1) {
                    onChange(__spreadArrays(value, [selected]));
                }
                else {
                    onChange(__spreadArrays(value.slice(0, idx), value.slice(idx + 1)));
                }
            }
        }
        else {
            onChange(selected);
            setTimeout(function () {
                if (inputEl && inputEl.current) {
                    inputEl.current.blur();
                }
            });
        }
        setInputValue('');
    }
    function handleKeyDown(event) {
        if (event.key === 'ArrowDown') {
            event.preventDefault();
            setFocusIdx((focusIdx + 1) % allOptions.length);
        }
        else if (event.key === 'ArrowUp') {
            event.preventDefault();
            setFocusIdx((focusIdx + allOptions.length - 1) % allOptions.length);
        }
        else if (event.key === 'Enter') {
            event.preventDefault();
            handleSelectOption(allOptions[focusIdx]);
        }
        else if (event.key === 'Escape') {
            if (inputEl && inputEl.current) {
                inputEl.current.blur();
            }
        }
    }
    function handleChangeInput(value) {
        setInputValue(value);
        if (onChangeInput) {
            onChangeInput(value);
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(react_media_1.default, { query: "(pointer: coarse)", onChange: function (matches) { return setIsTouchDevice(matches); } }),
        React.createElement(ContainerWrapper, null,
            React.createElement(Input_1.default, { value: value, onChange: function (newValue) { return onChange(newValue); }, inputValue: inputValue, onChangeInput: handleChangeInput, onFocus: handleFocus, onBlur: handleBlur, disabled: disabled, onKeyDown: handleKeyDown, ref: inputEl, inputEl: inputEl, focused: focused, multiple: multiple, loading: loading, isTouchDevice: isTouchDevice, error: error, id: formGroupContext.id, placeholder: placeholder, clearable: clearable }),
            focused && (React.createElement(Options_1.default, { createNewOption: createNewOption, inputValue: inputValue, loading: loading, options: filteredOptions, focusedIdx: focusIdx, onSelectOption: handleSelectOption, multiple: multiple, value: value, renderLabel: renderLabel }))),
        isTouchDevice && (React.createElement(OptionsModal_1.default, { options: filteredOptions, value: value, onSelectOption: handleSelectOption, onChange: onChange, opened: isModalOpened, multiple: multiple, inputValue: inputValue, onChangeInput: handleChangeInput, createNewOption: createNewOption, loading: loading, renderLabel: renderLabel, onClose: function () {
                setInputValue('');
                setIsModalOpened(false);
            } }))));
}
exports.default = default_1;
var templateObject_1;
